import { c as _c } from "react/compiler-runtime";
import { usePriceBox } from "@website/accommodation-ui/price-calendar-wrapper/price-box/hooks";
import { PriceCalendarItem } from "@website/accommodation-ui/price-calendar-wrapper/types";
import Link from "next/link";
import { ReactNode } from "react";
const sliderClassNames = "keen-slider__slide flex";
const DivComponent = t0 => {
  const $ = _c(6);
  let children;
  let properties;
  if ($[0] !== t0) {
    ({
      children,
      ...properties
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = properties;
  } else {
    children = $[1];
    properties = $[2];
  }
  let t1;
  if ($[3] !== children || $[4] !== properties) {
    t1 = <div {...properties}>{children}</div>;
    $[3] = children;
    $[4] = properties;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  return t1;
};
export const PriceBox = properties => {
  const $ = _c(17);
  const {
    isTodayPrice,
    link,
    price
  } = properties;
  const {
    formattedDate,
    formattedDateMobile,
    formattedPrice,
    priceBoxBgColor,
    priceColor,
    handleClick
  } = usePriceBox(properties);
  const ComponentTagName = price > 0 ? Link : DivComponent;
  const t0 = `${sliderClassNames} min-w-[88px] flex-col items-center justify-center gap-1 rounded-lg px-2 py-[6px] align-middle md:mx-1 md:min-w-[98px] md:first:mr-0 md:last:ml-0 lg:min-w-[104px] ${priceBoxBgColor} ${isTodayPrice ? "border-secondary border-2" : "border"}`;
  let t1;
  if ($[0] !== formattedDateMobile) {
    t1 = <span className="md:hidden">{formattedDateMobile}</span>;
    $[0] = formattedDateMobile;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== formattedDate) {
    t2 = <span className="hidden md:block">{formattedDate}</span>;
    $[2] = formattedDate;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t1 || $[5] !== t2) {
    t3 = <span className="text-on-surface-medium-emphasis text-caption whitespace-nowrap">{t1}{t2}</span>;
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const t4 = `whitespace-nowrap text-sm ${price > 0 ? priceColor : "text-gray-400"}`;
  let t5;
  if ($[7] !== formattedPrice || $[8] !== t4) {
    t5 = <span className={t4}>{formattedPrice}</span>;
    $[7] = formattedPrice;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== ComponentTagName || $[11] !== handleClick || $[12] !== link || $[13] !== t0 || $[14] !== t3 || $[15] !== t5) {
    t6 = <ComponentTagName className={t0} href={link} rel="nofollow" onClick={handleClick}>{t3}{t5}</ComponentTagName>;
    $[10] = ComponentTagName;
    $[11] = handleClick;
    $[12] = link;
    $[13] = t0;
    $[14] = t3;
    $[15] = t5;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  return t6;
};